// Invitanda pass 74 (2026-10-23): the one-tap add of snippets/mbf-set-add and snippets/mbf-pages-add (the same script, printed by both).

(function () {
  if (window.__mbcAdd) return;
  window.__mbcAdd = 1;
  var busy = false, done = false, last = null;
  var cartPath = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
  window.addEventListener('pageshow', function () { busy = false; if (last) { last.removeAttribute('aria-busy'); last = null; } });
  function swap(doc, sel) { var nb = doc.querySelector(sel), cb = document.querySelector(sel); if (!nb || !cb) return false; cb.innerHTML = nb.innerHTML; return true; }
  // ux-pass33: the cart drawer and the cart icon come back with the add itself (Shopify renders their two sections into
  // the answer), so they are drawn without reading this whole page again. Without them the page is read as before.
  function secIds() {
    var a = [];
    (window.__mbCartDraw ? ['cart-drawer-component'] : ['cart-drawer-component', 'cart-icon']).forEach(function (n) { var e = document.querySelector(n), s = e && e.closest('.shopify-section'); if (s && s.id && a.indexOf(s.id) < 0) a.push(s.id); });
    return a.map(function (x) { return x.replace(/^shopify-section-/, ''); });
  }
  function withSec(o) { var a = secIds(); if (a.length) { o.sections = a.join(','); o.sections_url = location.pathname; } return o; }
  function secHtml(j) { var s = j && j.sections, a = secIds(), h = ''; if (!s || !a.length) return ''; for (var i = 0; i < a.length; i++) { if (typeof s[a[i]] !== 'string') return ''; h += s[a[i]]; } return h; }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-mbc-add]') : null;
    if (!a) return;
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var f = a.closest('[data-mbc-form]'), sel = f ? f.querySelector('[data-mbc-var]') : null;
    var id = Number(a.getAttribute('data-mbc-add') || (sel && sel.value));
    if (!id) return;
    e.preventDefault();
    if (busy) return;
    if (done) { location.assign(cartPath); return; }
    var row = f || a.closest('[data-mbc-row], .mbc-cart__row, .mbcn__row');
    var err = row ? row.querySelector('[data-mbc-err]') : null;
    function say(text, el) {
      if (err) { err.textContent = text; err.hidden = false; }
      if (el) { if (el.type !== 'checkbox') el.setAttribute('aria-invalid', 'true'); try { el.focus(); } catch (x) {} }
    }
    if (err) { err.hidden = true; err.textContent = ''; }
    var item = { id: id, quantity: 1 };
    if (f) {
      // The name bag: never without a name of 1 to 20 characters and the ticked spelling box.
      var ne = f.querySelector('[data-mbc-name]'), tk = f.querySelector('[data-mbc-tick]'), props = {}, any = false;
      if (ne) {
        var nm = ne.value.trim();
        if (!nm || nm.length > 20) { say('Please type the name to stitch.', ne); return; }
        if (!(function () { try { return new RegExp("^[\\p{L}\\p{M}\\p{N} &'\\u2019.\\-]+$", 'u'); } catch (e) { return /^[A-Za-z\u00C0-\u024F0-9 &'\u2019.\-]+$/; } })().test(nm)) { say('Letters, numbers and spaces only.', ne); return; } // ux-pass41b: the stitched-name rule
        if (!tk || !tk.checked || !tk.value) { say('Please tick the box to confirm the spelling.', tk); return; }
      }
      Array.prototype.forEach.call(f.querySelectorAll('[data-mbc-prop]'), function (el) {
        var k = el.getAttribute('data-mbc-prop'), v = el.type === 'checkbox' ? (el.checked ? el.value : '') : String(el.value || '').trim();
        if (k && v) { props[k] = v; any = true; }
      });
      if (any) item.properties = props;
    }
    busy = true;
    last = a;
    a.setAttribute('aria-busy', 'true');
    // pass 49g: the round + of a cart tile (snippets/mb-acc-engine) turns into a green check at once.
    if (a.classList && a.classList.contains('mbct__add')) { a.__mbH = a.innerHTML; a.classList.add('is-added'); a.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" width="16" height="16"><path d="M3 8.5l3.2 3.2L13 5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>'; }
    // pass 61: the Add to cart of a slider card says Added with the check at once.
    if (a.classList && a.classList.contains('mbcs__add')) { a.__mbH = a.innerHTML; a.classList.add('is-added'); a.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 16 16" width="16" height="16"><path d="M3 8.5l3.2 3.2L13 5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>' + 'Added'; }
    var onCart0 = location.pathname === cartPath;
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(onCart0 ? { items: [item] } : withSec({ items: [item] }))
    })
      .then(function (r) {
        if (!r.ok) throw 0;
        // Redraw where she is, with no page load and no jump: the cart page itself, or the cart drawer of any other page.
        // ux-pass33: off the cart page the drawer and the icon came back with the add; the page is read only without them.
        var onCart = location.pathname === cartPath, y = window.scrollY;
        return (onCart ? Promise.resolve('') : r.json().then(secHtml, function () { return ''; }))
          .then(function (h0) { return h0 || fetch(onCart ? cartPath : location.pathname, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
          .then(function (p) { if (!p.ok) throw 1; return p.text(); }); })
          .then(function (html) {
            function fin() {
              busy = false; last = null;
              var live = document.querySelector('[data-mbc-live]');
              if (live) live.textContent = 'Added to your order.';
            }
            // pass 60: drawn in place (snippets/mb-cart-fix part 4): the photos, the list and what she looks at stay;
            // only what changed is written. The old way below stays as a fallback.
            var drawn = onCart ? (window.__mbCartPage ? window.__mbCartPage(html, { anchor: a }) : null) : (window.__mbCartDraw ? window.__mbCartDraw(html, { anchor: a }) : null);
            if (drawn) return drawn.then(function (ok) { if (!ok) throw 1; fin(); });
            var doc = new DOMParser().parseFromString(html, 'text/html');
            swap(doc, 'cart-icon');
            if (onCart) { if (!swap(doc, 'main')) throw 1; }
            else {
              var box = document.querySelector('cart-drawer-component .cart-drawer__content'), top = box ? box.scrollTop : 0;
              if (!swap(doc, 'cart-drawer-component')) throw 1;
              box = document.querySelector('cart-drawer-component .cart-drawer__content');
              if (box) box.scrollTop = top;
            }
            window.scrollTo(0, y);
            fin();
          })
          .catch(function () {
            // It is in her cart but the screen could not be redrawn. The cart page reloads itself; any other page stays.
            if (onCart) { done = true; location.assign(cartPath); return; }
            busy = false; last = null;
            a.removeAttribute('aria-busy');
            say('It is in your cart.');
          });
      })
      .catch(function () {
        busy = false; last = null;
        a.removeAttribute('aria-busy');
        if (a.__mbH) { a.innerHTML = a.__mbH; a.classList.remove('is-added'); }
        if (err) { say('We could not add this to your cart. Please try again.'); return; }
        // pass 22 (no exit): the link is followed on the cart page only. Any other page stays where it is.
        if (a.href && location.pathname === cartPath) location.assign(a.href);
      });
  });
  // The small name bag form of the cart notes: the photo follows the color, the counter follows the name, and an
  // edit of the name clears the tick (as on the name bag page). Enter never sends anything.
  function field(e) {
    var t = e.target, f = t && t.closest ? t.closest('[data-mbc-form]') : null;
    if (!f) return;
    var er = f.querySelector('[data-mbc-err]');
    if (t.hasAttribute('data-mbc-var')) {
      var o = t.options[t.selectedIndex], im = f.querySelector('[data-mbc-img]'), src = o ? o.getAttribute('data-img') : '';
      if (im && src) im.src = src;
      // pass 61: a slider card shows the price of its choice; a card whose Add to cart was used is ready again for the
      // new choice.
      var nw = f.querySelector('[data-mbc-now]'), ws = f.querySelector('[data-mbc-was]'), ab = f.querySelector('.mbcs__add.is-added');
      if (o && nw && o.getAttribute('data-now')) nw.textContent = o.getAttribute('data-now');
      if (o && ws) { var wv = o.getAttribute('data-was') || ''; ws.hidden = !wv; ws.innerHTML = '<span class="visually-hidden">Regular price </span>' + wv; }
      if (ab) { ab.classList.remove('is-added'); ab.disabled = false; ab.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8 2.5v11M2.5 8h11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>Add'; ab.__mbH = null; var an = f.querySelector('.mbcs__n'); ab.setAttribute('aria-label', 'Add ' + (an ? an.textContent.trim() : 'it') + ' to cart'); }
    }
    if (t.hasAttribute('data-mbc-name') && e.type === 'input') {
      var c = f.querySelector('[data-mbc-cnt]'), k = f.querySelector('[data-mbc-tick]');
      if (c) c.textContent = t.value.length + '/' + (t.getAttribute('maxlength') || 20);
      if (k && k.checked) k.checked = false;
      t.removeAttribute('aria-invalid');
      if (er) er.hidden = true;
    }
    if (t.hasAttribute('data-mbc-tick') && t.checked && er) er.hidden = true;
  }
  // pass 61 (owner, 2026-10-19; the model is the cart of Oh My Mahjong): the slider "Add to your table"
  // (snippets/mbc-cart-notes-core). One card at a time: she swipes it (the track scrolls), or the arrows move one card
  // (past the last one back to the first, as there), and "2 / 8" says where she is.
  function slideW(track) {
    var c = track.querySelector('.mbcs__card');
    return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : (track.clientWidth || 1);
  }
  function slideAt(track) {
    var n = track.querySelectorAll('.mbcs__card').length, w = slideW(track) || 1;
    return [Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w))), n];
  }
  function slidePaint(track) {
    var box = track.closest('[data-mbcs]'), c = box && box.querySelector('[data-mbcs-count]');
    if (!c) return;
    var s = slideAt(track), t = (s[0] + 1) + ' / ' + s[1];
    if (c.textContent !== t) c.textContent = t;
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-mbcs-track]')) return;
    clearTimeout(t.__mbT);
    t.__mbT = setTimeout(function () { slidePaint(t); }, 50);
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-mbcs-step]') : null;
    if (!b) return;
    e.preventDefault();
    var box = b.closest('[data-mbcs]'), track = box && box.querySelector('[data-mbcs-track]');
    if (!track) return;
    var s = slideAt(track), next = s[0] + (Number(b.getAttribute('data-mbcs-step')) || 0);
    if (next < 0) next = s[1] - 1;
    if (next >= s[1]) next = 0;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: next * slideW(track), behavior: calm ? 'auto' : 'smooth' });
  });
  // After the cart is drawn in place (snippets/mb-cart-fix part 4) a kept card can stand among the new ones.
  document.addEventListener('mb:cart-drawn', function () { [].forEach.call(document.querySelectorAll('[data-mbcs-track]'), slidePaint); });

  // pass 61 (owner: "Trong giỏ hàng chọn set thứ 2 nếu khách muốn chọn màu khác thì sao?"): the back color chips of the
  // list "Pick your second set". A chip sets what each "Add this set" adds (data-mbc-vmap: color~variant~cents|...) and
  // the line under each design; a design without that color hides. Nothing is added here.
  function money(c) { c = Math.round(c); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-mbc-back]') : null;
    if (!b) return;
    e.preventDefault();
    var box = b.closest('[data-mbc-backs]'), wrap = box && box.parentNode;
    if (!wrap) return;
    var name = b.getAttribute('data-mbc-back'), off = Number(box.getAttribute('data-mbc-off')) || 0;
    [].forEach.call(box.querySelectorAll('[data-mbc-back]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    var bn = box.querySelector('[data-mbc-backname]');
    if (bn) bn.textContent = name;
    [].forEach.call(wrap.querySelectorAll('[data-mbc-vmap]'), function (li) {
      var hit = null;
      String(li.getAttribute('data-mbc-vmap') || '').split('|').forEach(function (r) { var p = r.split('~'); if (p[0] === name && p[1]) hit = p; });
      li.hidden = !hit;
      if (!hit) return;
      var btn = li.querySelector('[data-mbc-add]'), tx = li.querySelector('[data-mbc-backtxt]'), pr = li.querySelector('[data-mbc-pprice]');
      var sz = li.getAttribute('data-mbc-sz') || '', line = (sz ? sz + ', ' : '') + name, c = Number(hit[2]) || 0;
      if (btn) { btn.setAttribute('data-mbc-add', hit[1]); btn.setAttribute('aria-label', 'Add the ' + (li.getAttribute('data-mbc-name') || '') + ' set, ' + line + ' back'); }
      if (tx) tx.textContent = line + ' back';
      var cm = Number(hit[3]) || 0; // pass 71: the design's struck price when no second-set amount applies
      if (pr && c) pr.innerHTML = off > 0 && c > off ? money(c - off) + ' <s><span class="visually-hidden">Regular price </span>' + money(c) + '</s>' : money(c) + (cm > c ? ' <s><span class="visually-hidden">Regular price </span>' + money(cm) + '</s>' : '');
    });
  });
  document.addEventListener('change', field);
  document.addEventListener('input', field);
  document.addEventListener('keydown', function (e) { var t = e.target; if (e.key === 'Enter' && t && t.hasAttribute && t.hasAttribute('data-mbc-name')) { e.preventDefault(); t.blur(); } });
})();
